export enum EventStatisticsTabs {
    BILLBOARD = "BILLBOARD", 
    ACCESS_CONTROL = "ACCESS_CONTROL"
}